module.exports = __webpack_public_path__ + "static/img/fans.d1d124a2.png";